import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toRight",
  "use": "icon-toRight-usage",
  "viewBox": "0 0 95.995 95.995",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 95.995 95.995\" id=\"icon-toRight\">\n<path d=\"M92.858,45.557L62.691,22.604l-0.002,4.31l27.897,21.26L92.858,45.557z M90.585,48.173\" />\n<polygon points=\"90.583,43.826 62.69,66.126 62.69,70.483 93.389,45.931 \" />\n<rect x=\"3.818\" y=\"53.933\" width=\"74.221\" height=\"3.998\" />\n<rect x=\"3.818\" y=\"34.356\" width=\"74.221\" height=\"3.998\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol